import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SearchResultCmsPageViewModel } from '@models/api.models';

@Injectable()
export class ChildrenLinksService {
    constructor(private http: HttpClient) {}

    public getContentChildren(pageId: string): Observable<SearchResultCmsPageViewModel[]> {
        return this.http.get<SearchResultCmsPageViewModel[]>(`content/children?id=${pageId}`);
    }
}
